export default __webpack_public_path__ + "static/media/bg-right.c754de85.jpg";